import { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import LoaderAction from "../../../../../Loader/LoaderHome";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useReactToPrint } from "react-to-print";
import LogoYpi from "../../../../../../assets/logo-rapor/ypi.png";
import LogoYsb from "../../../../../../assets/logo-rapor/ysb.png"

// import {
//   Document,
//   Packer,
//   Paragraph,
//   Table,
//   TableRow,
//   TableCell,
//   TextRun,
//   AlignmentType,
//   WidthType,
//   BorderStyle,
//   ImageRun,
// } from "docx";
// import { saveAs } from "file-saver";

import {
  Document,
  Packer,
  Paragraph,
  Table,
  TableRow,
  TableCell,
  TextRun,
  AlignmentType,
  WidthType,
  BorderStyle,
  ImageRun,
  VerticalAlign,
} from "docx";

 import { saveAs } from "file-saver";

export default function ModalRapor(props) {
  const [loading, setLoading] = useState(false);
  const safeValue = (value) => value ?? "";

  const capitalizeFirstLetter = (text) => {
  const t = String(text ?? "");
  // cari huruf pertama (abaikan spasi / simbol di depan)
    return t.replace(
      /^(\s*[^A-Za-zÀ-ÖØ-öø-ÿ]*)([a-zà-öø-ÿ])/,
      (_, prefix, ch) => prefix + ch.toLocaleUpperCase("id-ID")
    );
  };


  // Hilangkan kata tertentu di kolom "Indikator"
  // contoh: "Murid membiasakan ..." -> "..."
  // const cleanIndikator = (text) => {
  //   const t = String(text ?? "");
  //   return t
  //     .replace(/\bMurid\b\s*/gi, "")
  //     .replace(/\bmembiasakan\b\s*/gi, "")
  //     .replace(/\mempraktekkan\b\s*/gi, "")
  //     .replace(/\s{2,}/g, " ")
  //     .trim();  
  // };

  const cleanIndikator = (text) => {
  const t = String(text ?? "");
    const cleaned = t
      .replace(/\bMurid\b\s*/gi, "")
      .replace(/\bmembiasakan\b\s*/gi, "")
      .replace(/\s{2,}/g, " ")
      .trim();

    return capitalizeFirstLetter(cleaned);
  };


  // gunakan tanggal hari ini (format Indonesia)
  const today = new Date();
  const formattedDate = today.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => {
      const el = document.getElementById("printThis");
      return el;
    },
  });

  const abc = props?.data_kop;
  console.log(abc)

  const [data, setData] = useState({
    name_student: "",
    nisn: "",
    ysb_school_name: "",
    ysb_school_id: "",
    ysb_name_level: "",
    ysb_name_kelas: "",
    ysb_name_year: "",
    ysb_name_teacher: "",
    ysb_nama_kepsek: "",
    ysb_semester:""
  });

  const [dataKop, setDataKop] = useState({
    name_school: "",
    address: "",
    akreditasi: "",
    npsn: "",
    nss: "",
    phone: "",
    postal_code: "",
    province: "",
    district: "",
    name_branch: ""
  });


  // useEffect(() => {
  //   setData((prev) => ({
  //     ...prev,
  //     name_student: safeValue(props?.data_rapor?.name_student),
  //     nisn: safeValue(props?.data_rapor?.nisn),
  //     ysb_school_name: safeValue(props?.data_rapor?.ysb_school_name),
  //     ysb_school_id: safeValue(props?.data_rapor?.ysb_school_id),
  //     ysb_name_level: safeValue(props?.data_rapor?.ysb_name_level),
  //     ysb_name_kelas: safeValue(props?.data_rapor?.ysb_name_kelas),
  //     ysb_name_year: safeValue(props?.data_rapor?.ysb_name_year),
  //     ysb_name_teacher: safeValue(props?.data_rapor?.wali_kelas_utama),
  //     ysb_name_teacher2: safeValue(props?.data_rapor?.wali_kelas_pendamping),
  //     ysb_nama_kepsek: safeValue(props?.data_rapor?.ysb_nama_kepsek),
  //     ysb_semester: safeValue(props?.data_rapor?.ysb_semester)
  //   }));
  //   setDataKop((prev) => ({
  //     ...prev,
  //     name_school: safeValue(props?.data_kop?.name_school),
  //     address: safeValue(props?.data_kop?.address),
  //     district: safeValue(props?.data_kop?.district),
  //     akreditasi: safeValue(props?.data_kop?.akreditasi),
  //     npsn: safeValue(props?.data_kop?.npsn),
  //     nss: safeValue(props?.data_kop?.nss),
  //     phone: safeValue(props?.data_kop?.phone),
  //     postal_code: safeValue(props?.data_kop?.postal_code),
  //     province: safeValue(props?.data_kop?.province),
  //     name_branch: safeValue(props?.data_kop?.name_branch)
  //   }));
  // }, [props?.data, props?.data_kop]);

  useEffect(() => {
    setData({
      name_student: safeValue(props?.data_rapor?.name_student),
      nisn: safeValue(props?.data_rapor?.nisn),
      ysb_school_name: safeValue(props?.data_rapor?.ysb_school_name),
      ysb_school_id: safeValue(props?.data_rapor?.ysb_school_id),
      ysb_name_level: safeValue(props?.data_rapor?.ysb_name_level),
      ysb_name_kelas: safeValue(props?.data_rapor?.ysb_name_kelas),
      ysb_name_year: safeValue(props?.data_rapor?.ysb_name_year),
      ysb_name_teacher: safeValue(props?.data_rapor?.wali_kelas_utama),
      ysb_name_teacher2: safeValue(props?.data_rapor?.wali_kelas_pendamping),
      ysb_nama_kepsek: safeValue(props?.data_rapor?.ysb_nama_kepsek),
      ysb_semester: safeValue(props?.data_rapor?.ysb_semester),
    });

    setDataKop({
      name_school: safeValue(props?.data_kop?.name_school),
      address: safeValue(props?.data_kop?.address),
      district: safeValue(props?.data_kop?.district),
      akreditasi: safeValue(props?.data_kop?.akreditasi),
      npsn: safeValue(props?.data_kop?.npsn),
      nss: safeValue(props?.data_kop?.nss),
      phone: safeValue(props?.data_kop?.phone),
      postal_code: safeValue(props?.data_kop?.postal_code),
      province: safeValue(props?.data_kop?.province),
      name_branch: safeValue(props?.data_kop?.name_branch),
    });
  }, [props?.data_rapor, props?.data_kop]);



  // =========================
  // NORMALIZER: support struktur JSON baru + fallback struktur lama
  // JSON baru:
  // dimensi: [
  //   { type: "Adab Prioritas Kampus", dimensis: [ { ysb_dimensi_name, data_elements: [...] } ] }
  // ]
  // Struktur lama (fallback):
  // dimensi: [ { ysb_dimensi_name, data_elements: [...] } ]
  // =========================
  const normalizeDimensiGroups = (dimensiArr = []) => {
    if (!Array.isArray(dimensiArr)) return [];

    return dimensiArr.map((group) => {
      // jika sudah ada "dimensis" (struktur baru)
      if (Array.isArray(group?.dimensis)) {
        return {
          type: group?.type || "Muatan Adab",
          dimensis: group.dimensis,
        };
      }

      // fallback: dianggap sebagai 1 dimensi tanpa pengelompokan
      return {
        type: group?.type || "Muatan Adab",
        dimensis: [group],
      };
    });
  };

  // sumber data rapor: dari HomeRapor kamu ngirim "getData"
  const allRapor = props?.getData || props?.getRapor || [];

  const raporForStudent =
    (allRapor || []).find(
      (r) => (r?.ysb_student_id || r?.id) === props?.id_student
    ) || null;

  const dimensiGroups = normalizeDimensiGroups(raporForStudent?.dimensi || []);

  // GET CITY
  const getCityBySchoolId = (schoolId) => {
    const id = String(schoolId || "").trim().toLowerCase().replace(/\s+/g, "");
    if (id === "sdia62" || id === "smpia42" || id === "smaia42") return "Bandung";
    if (id === "sdia61" || id === "smpia41") return "Tangerang";
    if (id === "sdia44" || id === "smpia31" || id === "smaia8") return "Bekasi";
    if (id === "sdia68" ) return "Makassar";
    return ""; // fallback default (ubah kalau mau)
  };

  const cityName = getCityBySchoolId(data?.ysb_school_id);

  const imageToBase64 = async (src) => {
    const response = await fetch(src);
    const blob = await response.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

const imageToArrayBuffer = async (src) => {
  const response = await fetch(src);
  return await response.arrayBuffer();
};

const noBorder = {
  top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
  bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
  left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
  right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
};

// DOWLOAD WORD (layout fix supaya sama seperti screenshot)
// const handleDownloadWord = async () => {
//   const tableEl = document.querySelector("#printThis .table-print table");
//   if (!tableEl) return;

//   const logoYpiBase64 = await imageToBase64(LogoYpi);
//   const logoYsbBase64 = await imageToBase64(LogoYsb);

//   const safe = (v) => (v === null || v === undefined ? "" : String(v));

//   const studentName = toTitleCase(safe(data?.name_student));
//   const nisn = safe(data?.nisn);
//   const schoolName =  toTitleCase(safe(data?.ysb_school_name));
//   const kelas = `${safe(data?.ysb_name_level)} - ${toTitleCase(safe(data?.ysb_name_kelas))}`;
//   const ta = safe(data?.ysb_name_year);
//   const waliKelas = toTitleCase(safe(data?.ysb_name_teacher));
//   const kepsek = toTitleCase(safe(data?.ysb_nama_kepsek));
//   const kota = safe(cityName);
//   const tanggal = safe(formattedDate);

//   const kopSchoolName = toSchoolCase(safe(dataKop?.name_school));
//   const kopAddress = safe(dataKop?.address);
//   const kopDistrict = safe(dataKop?.district);
//   const kopPostalCode = safe(dataKop?.postal_code);
//   const kopPhone = safe(dataKop?.phone);
//   const kopNss = safe(dataKop?.nss);
//   const kopNpsn = safe(dataKop?.npsn);
//   const kopAkreditasi = safe(dataKop?.akreditasi);

//   // ambil hanya tabel rapor dari DOM supaya konten tetap sama
//   const raporTableHtml = tableEl.outerHTML;

//   const htmlContent = `
//   <html xmlns:o="urn:schemas-microsoft-com:office:office"
//         xmlns:w="urn:schemas-microsoft-com:office:word"
//         xmlns="http://www.w3.org/TR/REC-html40">
//     <head>
//       <meta charset="utf-8" />
//       <title>Laporan Hasil Capaian Adab</title>
//       <style>
//         @page {
//           size: Letter portrait;
//           margin: 0.55in 0.5in 0.55in 0.5in;
//         }

//         body {
//           font-family: Arial, sans-serif;
//           font-size: 12pt;
//           line-height: 1.35;
//           color: #111;
//           margin: 0;
//           padding: 0;
//         }

//         .doc-wrap {
//           width: 100%;
//           margin: 0 auto;
//         }

//         .title {
//           text-align: center;
//           font-size: 16pt;
//           font-weight: 700;
//           margin: 20px 0 20px 0;
//         }

   
//         .kop-box {
//           width: 100%;
//           padding: 10px 14px;
//           margin-bottom: 3px;
//         }

//         .kop-table {
//           width: 100%;
//           border-collapse: collapse;
//           table-layout: fixed;
//         }

//         .kop-table td {
//           border: none !important;
//           padding: 0;
//           vertical-align: middle;
//         }

//         .kop-logo-left {
//           width: 18%;
//           text-align: left;
//         }

//         .kop-logo-right {
//           width: 18%;
//           text-align: right;
//         }

//         .kop-logo-left img {
//           width: 78px;
//           height: auto;
//         }

//         .kop-logo-right img {
//           width: 90px;
//           height: auto;
//         }

//         .kop-center {
//           width: 64%;
//           text-align: center;
//         }

//         .kop-title {
//           font-size: 16pt;
//           font-weight: 700;
//           letter-spacing: 1px;
//           margin-bottom: 6px;
//         }

//         .kop-text {
//           font-size: 9.5pt;
//           line-height: 1.25;
//         }

//         .kop-status {
//           font-size: 10.5pt;
//           line-height: 1.25;
//           font-weight: 700;
//         }

//         .kop-line-table {
//   width: 100%;
//   border-collapse: collapse;
//   margin-bottom: 18px;
// }

// .kop-line-table td {
//   border-top: 5px solid #1d1d1d !important;
//   height: 4px;
//   padding: 0;
// }
//         /* ===== BLOK HEADER IDENTITAS (PRESISI WORD) ===== */
//         .meta {
//           width: 100%;
//           border-collapse: collapse;
//           table-layout: fixed;
//           margin-bottom: 14px;
//         }
//         .meta td {
//           border: none !important;
//           vertical-align: top;
//           padding: 0;
//           font-size: 12pt;
//         }
//         .meta .left { width: 58%; padding-right: 10px; }
//         .meta .right { width: 42%; }

//         .pair {
//           width: 100%;
//           border-collapse: collapse;
//           table-layout: fixed;
//         }
//         .pair td {
//           border: none !important;
//           padding: 0 0 7px 0;
//           vertical-align: top;
//           font-size: 12pt;
//         }
//         .label { width: 42%; }
//         .colon { width: 4%; text-align: center; }
//         .value { width: 54%; }

//         /* ===== TABEL RAPOR ===== */
//         table {
//           border-collapse: collapse;
//           width: 100%;
//           table-layout: fixed;
//           word-wrap: break-word;
//         }
//         th, td {
//           border: 1px solid #7a7a7a !important;
//           padding: 6px 7px;
//           vertical-align: top;
//           font-size: 10.5pt;
//         }
//         th { text-align: center; }
//         .text-center { text-align: center !important; }

//         /* ===== BLOK TTD BAWAH (PRESISI WORD) ===== */
//         .ttd-wrap {
//           width: 100%;
//           margin-top: 18px;
//           font-size: 12pt;
//         }

//         .tanggal {
//           width: 100%;
//           text-align: right;
//           margin-bottom: 14px;
//           font-size: 12pt;
//         }

//         .ttd-2col {
//           width: 100%;
//           border-collapse: collapse;
//           table-layout: fixed;
//           margin-bottom: 12px;
//         }
//         .ttd-2col td {
//           border: none !important;
//           width: 50%;
//           vertical-align: top;
//           font-size: 12pt;
//         }
//         .ttd-left { text-align: left; }
//         .ttd-right { text-align: right; }

//         .sign-space-1 { height: 56px; }
//         .sign-space-2 { height: 62px; }

//         .line {
//           letter-spacing: 1px;
//           white-space: nowrap;
//         }

//         .kepsek {
//           width: 100%;
//           text-align: center;
//           margin-top: 18px;
//           font-size: 12pt;
//         }

//         .nama-bold { font-weight: 700; }
//       </style>
//     </head>
//     <body>
//       <div class="doc-wrap">
//       <div class="kop-box">
//   <table class="kop-table">
//     <tr>
//       <td class="kop-logo-left">
//         <img src="${logoYpiBase64}" width="85" height="85" style="width:85px;height:85px;" />
//       </td>

//       <td class="kop-center">
//         <div class="kop-title">${kopSchoolName}</div>
//         <div class="kop-text">${kopAddress} - ${kopDistrict}, ${kopPostalCode}</div>
//         <div class="kop-text">Telp : ${kopPhone}</div>
//         <div class="kop-text">NSS : ${kopNss} NPSN : ${kopNpsn}</div>
//         <div class="kop-status">Status Terakreditasi : ${kopAkreditasi}</div>
//       </td>

//       <td class="kop-logo-right">
//        <img src="${logoYsbBase64}" width="85" height="85" style="width:85px;height:85px;" />
//       </td>
//     </tr>
//   </table>
// </div>

// <table class="kop-line-table">
//   <tr>
//     <td></td>
//   </tr>
// </table>

//         <div class="title">LAPORAN HASIL CAPAIAN ADAB</div>

//         <!-- Header identitas -->
//         <table class="meta">
//           <tr>
//             <td class="left">
//               <table class="pair">
//                 <tr>
//                   <td class="label">Nama</td><td class="colon">:</td><td class="value">${studentName}</td>
//                 </tr>
//                 <tr>
//                   <td class="label">NISN</td><td class="colon">:</td><td class="value">${nisn}</td>
//                 </tr>
//                 <tr>
//                   <td class="label">Nama Sekolah</td><td class="colon">:</td><td class="value">${schoolName}</td>
//                 </tr>
//               </table>
//             </td>
//             <td class="right">
//               <table class="pair">
//                 <tr>
//                   <td class="label">Kelas</td><td class="colon">:</td><td class="value">${kelas}</td>
//                 </tr>
//                 <tr>
//                   <td class="label">TA</td><td class="colon">:</td><td class="value">${ta}</td>
//                 </tr>
//               </table>
//             </td>
//           </tr>
//         </table>

//         <!-- Tabel rapor asli -->
//         ${raporTableHtml}

//         <!-- TTD -->
//         <div class="ttd-wrap">
//           <div class="tanggal">${kota}, ${tanggal}</div>
//           <br/>
//           <br />

//           <table class="ttd-2col">
//             <tr>
//               <td class="ttd-left">
//                 <div>Orang Tua/Wali Peserta Didik</div>
//                 <div class="sign-space-1"></div>
//                 <br />
//                 <br/>
//                 <br />
//                 <br />
//                 <div class="line">__________________________</div>
//               </td>
//               <td class="ttd-right">
//                 <div>Wali Kelas ${safe(data?.ysb_name_level)} - ${toTitleCase(safe(data?.ysb_name_kelas))}</div>
//                 <div class="sign-space-1"></div>
//                 <br />
//                 <br/>
//                 <br />
//                 <br />
//                 <div class="nama-bold">${waliKelas}</div>
//               </td>
//             </tr>
//           </table>

//           <div class="kepsek">
//             <div>Mengetahui,</div>
//             <div>Kepala Sekolah</div>
//             <div class="sign-space-2"></div>
//             <br />
//                 <br/>
//                 <br />
//                 <br />
//             <div class="nama-bold">${kepsek}</div>
//           </div>
//         </div>
//       </div>
//     </body>
//   </html>
//   `;

//   const blob = new Blob(["\ufeff", htmlContent], {
//     type: "application/msword;charset=utf-8",
//   });

//   const url = URL.createObjectURL(blob);
//   const link = document.createElement("a");
//   const fileName = (data?.name_student || "rapor").replace(/[^\w\s-]/g, "").trim();
//   link.href = url;
//   link.download = `Rapor_${fileName || "Siswa"}.doc`;
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
//   URL.revokeObjectURL(url);
// };


const handleDownloadWord = async () => {
  const safe = (v) => (v === null || v === undefined ? "" : String(v));

  const logoYpiBuffer = await imageToArrayBuffer(LogoYpi);
  const logoYsbBuffer = await imageToArrayBuffer(LogoYsb);

  const studentName = toTitleCase(safe(data?.name_student));
  const nisn = safe(data?.nisn);
  const schoolName = toSchoolCase(safe(data?.ysb_school_name));
  const kelas = `${safe(data?.ysb_name_level)} - ${toTitleCase(safe(data?.ysb_name_kelas))}`;
  const tahunAjaran = safe(data?.ysb_name_year);
  const semester = safe(data?.ysb_semester);
  const waliKelas = toTitleCase(safe(data?.ysb_name_teacher));
  const waliKelas2 = toTitleCase(safe(data?.ysb_name_teacher2));
  const kepsek = toTitleCase(safe(data?.ysb_nama_kepsek));
  const kota = safe(cityName);
  const tanggal = safe(formattedDate);

  const kopSchoolName = toSchoolCase(safe(dataKop?.name_school));
  const kopAddress = safe(dataKop?.address);
  const kopDistrict = safe(dataKop?.district);
  const kopPostalCode = safe(dataKop?.postal_code);
  const kopPhone = safe(dataKop?.phone);
  const kopNss = safe(dataKop?.nss);
  const kopNpsn = safe(dataKop?.npsn);
  const kopAkreditasi = safe(dataKop?.akreditasi);

  const makeText = (text, options = {}) =>
    new TextRun({
      text: safe(text),
      font: "Arial",
      size: options.size || 22,
      bold: options.bold || false,
    });

  const makeParagraph = (text, options = {}) =>
    new Paragraph({
      alignment: options.align || AlignmentType.LEFT,
      spacing: { after: options.after || 80 },
      children: [makeText(text, options)],
    });

  // const makeCell = (children, options = {}) =>
  //   new TableCell({
  //     width: options.width
  //       ? { size: options.width, type: WidthType.PERCENTAGE }
  //       : undefined,
  //     borders: options.noBorder ? noBorder : undefined,
  //     verticalAlign: options.verticalAlign || "center",
  //     children: Array.isArray(children) ? children : [children],
  //   });

  const makeCell = (children, options = {}) =>
  new TableCell({
    width: options.width
      ? { size: options.width, type: WidthType.PERCENTAGE }
      : undefined,
    borders: options.noBorder ? noBorder : undefined,
    verticalAlign: options.verticalAlign || VerticalAlign.CENTER,
    children: Array.isArray(children) ? children : [children],
  });

  const makeInfoRow = (label, value) =>
    new TableRow({
      children: [
        makeCell(makeParagraph(label), { noBorder: true, width: 32 }),
        makeCell(makeParagraph(":"), { noBorder: true, width: 4 }),
        makeCell(makeParagraph(value), { noBorder: true, width: 64 }),
      ],
    });

  const raporRows = [];

  if (!raporForStudent || dimensiGroups.length === 0) {
    raporRows.push(
      new TableRow({
        children: [
          makeCell(makeParagraph("Data rapor belum tersedia.", { align: AlignmentType.CENTER }), {
            width: 100,
          }),
        ],
      })
    );
  } else {
    dimensiGroups.forEach((group, gIdx) => {
      const letter = String.fromCharCode(65 + gIdx);

      raporRows.push(
        new TableRow({
          children: [
            new TableCell({
              columnSpan: 4,
              shading: { fill: "F2F2F2" },
              children: [
                makeParagraph(`${letter}. ${group?.type || "Muatan Adab"}`, {
                  bold: true,
                }),
              ],
            }),
          ],
        })
      );

      (group.dimensis || []).forEach((dim, dimIdx) => {
        raporRows.push(
          new TableRow({
            children: [
              new TableCell({
                columnSpan: 4,
                shading: { fill: "F8F8F8" },
                children: [
                  makeParagraph(`${dimIdx + 1}. ${dim?.ysb_dimensi_name || "-"}`, {
                    bold: true,
                  }),
                ],
              }),
            ],
          })
        );

        (dim?.data_elements || []).forEach((el) => {
          const indikatorText =
            (el?.sub_elements || [])
              .map((sub, i) => `${i + 1}. ${cleanIndikator(sub?.ysb_sub_element_name) || "-"}`)
              .join("\n") || "-";

          raporRows.push(
            new TableRow({
              children: [
                makeCell(makeParagraph(el?.description || "-"), { width: 12 }),
                makeCell(makeParagraph(indikatorText), { width: 45 }),
                makeCell(makeParagraph(el?.kkca_description || "-", { align: AlignmentType.CENTER }), {
                  width: 15,
                }),
                makeCell(makeParagraph(el?.kkca_description_full || "-"), { width: 28 }),
              ],
            })
          );
        });
      });
    });
  }

  const doc = new Document({
    sections: [
      {
        properties: {
          page: {
            margin: {
              top: 720,
              right: 720,
              bottom: 720,
              left: 720,
            },
          },
        },
        children: [
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            borders: {
              top: { style: BorderStyle.SINGLE, size: 12, color: "F05A1A" },
              bottom: { style: BorderStyle.SINGLE, size: 12, color: "F05A1A" },
              left: { style: BorderStyle.SINGLE, size: 12, color: "F05A1A" },
              right: { style: BorderStyle.SINGLE, size: 12, color: "F05A1A" },
              insideHorizontal: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
              insideVertical: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
            },
            rows: [
              new TableRow({
                children: [
                  makeCell(
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new ImageRun({
                          data: logoYpiBuffer,
                          transformation: { width: 70, height: 70 },
                        }),
                      ],
                    }),
                    { width: 18, noBorder: true }
                  ),
                  makeCell(
                    [
                      makeParagraph(kopSchoolName, {
                        align: AlignmentType.CENTER,
                        bold: true,
                        size: 28,
                        after: 60,
                      }),
                      makeParagraph(`${kopAddress} - ${kopDistrict}, ${kopPostalCode}`, {
                        align: AlignmentType.CENTER,
                        size: 20,
                        after: 20,
                      }),
                      makeParagraph(`Telp : ${kopPhone}`, {
                        align: AlignmentType.CENTER,
                        size: 20,
                        after: 20,
                      }),
                      makeParagraph(`NSS : ${kopNss} NPSN : ${kopNpsn}`, {
                        align: AlignmentType.CENTER,
                        size: 20,
                        after: 20,
                      }),
                      makeParagraph(`Status Terakreditasi : ${kopAkreditasi}`, {
                        align: AlignmentType.CENTER,
                        bold: true,
                        size: 20,
                        after: 20,
                      }),
                    ],
                    { width: 64, noBorder: true }
                  ),
                  makeCell(
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new ImageRun({
                          data: logoYsbBuffer,
                          transformation: { width: 82, height: 82 },
                        }),
                      ],
                    }),
                    { width: 18, noBorder: true }
                  ),
                ],
              }),
            ],
          }),

          new Paragraph({
            border: {
              bottom: {
                color: "BFBFBF",
                space: 1,
                style: BorderStyle.SINGLE,
                size: 18,
              },
            },
            spacing: { after: 300 },
          }),

          makeParagraph("LAPORAN HASIL CAPAIAN ADAB", {
            align: AlignmentType.CENTER,
            bold: true,
            size: 30,
            after: 260,
          }),

          // new Table({
          //   width: { size: 100, type: WidthType.PERCENTAGE },
          //   borders: {
          //     top: { style: BorderStyle.NONE },
          //     bottom: { style: BorderStyle.NONE },
          //     left: { style: BorderStyle.NONE },
          //     right: { style: BorderStyle.NONE },
          //     insideHorizontal: { style: BorderStyle.NONE },
          //     insideVertical: { style: BorderStyle.NONE },
          //   },
          //   rows: [
          //     new TableRow({
          //       children: [
          //         makeCell(
          //           new Table({
          //             width: { size: 100, type: WidthType.PERCENTAGE },
          //             borders: {
          //               top: { style: BorderStyle.NONE },
          //               bottom: { style: BorderStyle.NONE },
          //               left: { style: BorderStyle.NONE },
          //               right: { style: BorderStyle.NONE },
          //               insideHorizontal: { style: BorderStyle.NONE },
          //               insideVertical: { style: BorderStyle.NONE },
          //             },
          //             rows: [
          //               makeInfoRow("Nama", studentName),
          //               makeInfoRow("NISN", nisn),
          //               makeInfoRow("Nama Sekolah", schoolName),
          //             ],
          //           }),
          //           { width: 58, noBorder: true }
          //         ),
          //         makeCell(
          //           new Table({
          //             width: { size: 100, type: WidthType.PERCENTAGE },
          //             borders: {
          //               top: { style: BorderStyle.NONE },
          //               bottom: { style: BorderStyle.NONE },
          //               left: { style: BorderStyle.NONE },
          //               right: { style: BorderStyle.NONE },
          //               insideHorizontal: { style: BorderStyle.NONE },
          //               insideVertical: { style: BorderStyle.NONE },
          //             },
          //             rows: [
          //               makeInfoRow("Kelas", kelas),
          //               makeInfoRow("Tahun Ajaran", tahunAjaran),
          //               makeInfoRow("Semester", semester),
          //             ],
          //           }),
          //           { width: 42, noBorder: true }
          //         ),
          //       ],
          //     }),
          //   ],
          // }),

          new Table({
  width: { size: 100, type: WidthType.PERCENTAGE },
  borders: {
    top: { style: BorderStyle.NONE },
    bottom: { style: BorderStyle.NONE },
    left: { style: BorderStyle.NONE },
    right: { style: BorderStyle.NONE },
    insideHorizontal: { style: BorderStyle.NONE },
    insideVertical: { style: BorderStyle.NONE },
  },
  rows: [
    new TableRow({
      children: [
        makeCell(makeParagraph("Nama"), { width: 18, noBorder: true }),
        makeCell(makeParagraph(":"), { width: 3, noBorder: true }),
        makeCell(makeParagraph(studentName), { width: 34, noBorder: true }),

        makeCell(makeParagraph("Kelas"), { width: 15, noBorder: true }),
        makeCell(makeParagraph(":"), { width: 3, noBorder: true }),
        makeCell(makeParagraph(kelas), { width: 27, noBorder: true }),
      ],
    }),
    new TableRow({
      children: [
        makeCell(makeParagraph("NISN"), { width: 18, noBorder: true }),
        makeCell(makeParagraph(":"), { width: 3, noBorder: true }),
        makeCell(makeParagraph(nisn), { width: 34, noBorder: true }),

        makeCell(makeParagraph("Tahun Ajaran"), { width: 15, noBorder: true }),
        makeCell(makeParagraph(":"), { width: 3, noBorder: true }),
        makeCell(makeParagraph(tahunAjaran), { width: 27, noBorder: true }),
      ],
    }),
    new TableRow({
      children: [
        makeCell(makeParagraph("Nama Sekolah"), { width: 18, noBorder: true }),
        makeCell(makeParagraph(":"), { width: 3, noBorder: true }),
        makeCell(makeParagraph(schoolName), { width: 34, noBorder: true }),

        makeCell(makeParagraph("Semester"), { width: 15, noBorder: true }),
        makeCell(makeParagraph(":"), { width: 3, noBorder: true }),
        makeCell(makeParagraph(semester), { width: 27, noBorder: true }),
      ],
    }),
  ],
}),

          new Paragraph({ spacing: { after: 160 } }),

          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  makeCell(makeParagraph("Muatan\nAdab", { align: AlignmentType.CENTER, bold: true }), {
                    width: 12,
                  }),
                  makeCell(makeParagraph("Indikator", { align: AlignmentType.CENTER, bold: true }), {
                    width: 45,
                  }),
                  makeCell(makeParagraph("Capaian", { align: AlignmentType.CENTER, bold: true }), {
                    width: 15,
                  }),
                  makeCell(makeParagraph("Deskripsi Pencapaian", { align: AlignmentType.CENTER, bold: true }), {
                    width: 28,
                  }),
                ],
              }),
              ...raporRows,
            ],
          }),

          new Paragraph({ spacing: { after: 260 } }),

          makeParagraph(`${kota}, ${tanggal}`, {
            align: AlignmentType.RIGHT,
            after: 260,
          }),

          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            borders: {
              top: { style: BorderStyle.NONE },
              bottom: { style: BorderStyle.NONE },
              left: { style: BorderStyle.NONE },
              right: { style: BorderStyle.NONE },
              insideHorizontal: { style: BorderStyle.NONE },
              insideVertical: { style: BorderStyle.NONE },
            },
            rows: [
              new TableRow({
                children: [
                  makeCell(
                    [
                      makeParagraph("Orang Tua/Wali Peserta Didik"),
                      new Paragraph({ spacing: { after: 900 } }),
                      makeParagraph("__________________________"),
                    ],
                    { width: 50, noBorder: true }
                  ),
                  makeCell(
                    [
                      makeParagraph(`Wali Kelas ${safe(data?.ysb_name_level)} - ${toTitleCase(safe(data?.ysb_name_kelas))}`, {
                        align: AlignmentType.RIGHT,
                      }),
                      new Paragraph({ spacing: { after: 900 } }),
                      makeParagraph(waliKelas2 ? `${waliKelas}     ${waliKelas2}` : waliKelas, {
                        align: AlignmentType.RIGHT,
                        bold: true,
                      }),
                    ],
                    { width: 50, noBorder: true }
                  ),
                ],
              }),
            ],
          }),

          new Paragraph({ spacing: { after: 280 } }),

          makeParagraph("Mengetahui,", {
            align: AlignmentType.CENTER,
            after: 40,
          }),
          makeParagraph("Kepala Sekolah", {
            align: AlignmentType.CENTER,
            after: 900,
          }),
          makeParagraph(kepsek, {
            align: AlignmentType.CENTER,
            bold: true,
          }),
        ],
      },
    ],
  });

  const blob = await Packer.toBlob(doc);
  const fileName = (data?.name_student || "rapor")
      .replace(/[^\w\s-]/g, "")
      .trim();

    saveAs(blob, `Rapor_${fileName || "Siswa"}.docx`);
  };

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

  const toSchoolCase = (value) => {
    const s = safeStr(value).trim();
    if (!s) return "";

    const UPPER_WORDS = new Set(["SD", "SMP", "SMA"]);

    return s
      .split(/\s+/)
      .map((w) => {
        const upper = w.toUpperCase();
        if (UPPER_WORDS.has(upper)) return upper; // pertahankan singkatan
        return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
      })
      .join(" ");
  };

  const hasTeacher2 = safeStr(data?.ysb_name_teacher2).trim() !== "";

const toTitleCaseGelar = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";

    return s
      .split(" ")
      .map((word) => {
        // khusus gelar yang ada titik, contoh: s.si. -> S.Si.
        if (word.includes(".")) {
          return word
            .split(".")
            .map((part) => {
              if (!part) return "";
              return part.charAt(0).toUpperCase() + part.slice(1);
            })
            .join(".");
        }

        // normal title case, contoh: helmy -> Helmy
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const formatNamaKelas = (level, kelas) => {
    const levelText = level ? String(level).trim() : "";
    const kelasText = kelas ? String(kelas).trim() : "";

    if (!kelasText) return levelText;

    // ambil karakter pertama dari ysb_name_kelas
    const firstChar = kelasText.charAt(0);

    // jika nilai depan ysb_name_kelas angka, tampilkan pakai "-"
    if (/^\d$/.test(firstChar)) {
      return `${levelText} - ${toTitleCase(kelasText)}`;
    }

    // jika nilai depan ysb_name_kelas huruf, tampilkan biasa
    return `${levelText} ${toTitleCase(kelasText)}`;
  };

  return (
    <div className="modal">
      {loading && <LoaderAction />}

      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // backdrop="static"
      >
        <div className="d-flex header-modal">
          {/* <h5>{data?.name_student}</h5> */}
          <h5>{toTitleCase(data?.name_student)}</h5>

          <div className="ml-auto x-close">
            <FontAwesomeIcon
              icon={faXmark}
              onClick={() => props.onHide && props.onHide()}
            />
          </div>
        </div>

        <hr />

        <Modal.Body className="modal-body" style={{fontSize: "13px"}}>
          <div className="d-flex">
            <div className="ml-auto">

              <button
                onClick={handleDownloadWord}
                className="btn mb-3 mr-3"
                style={{
                  backgroundColor: "rgb(26, 82, 236)",
                  color: "#fff",
                  fontSize: "14px",
                }}
              >
                Download (Word Docs)
              </button>

              
              <button
                onClick={handlePrint}
                className="btn  mb-3"
                style={{
                  backgroundColor: "#eca91aff",
                  color: "#fff",
                  fontSize: "14px",
                }}
              >
                Print
              </button>
            </div>
            
          </div>

          <div
            ref={componentRef}
            style={{ border: "1px solid #e2e2e2ff", paddingTop: "20px" }}
          >
            
            <div
              id="printThis"
              className="wrap"
              style={{ margin: "0px 30px 50px 30px" , fontSize: "14px" }} 
            >

              {/* Kop Rapor */}
              <div className="row ">
                <div className="col-2">
                  <img src={LogoYpi}/>
                </div>

                <div className="col-8">
                  <div className="text-center">
                    <h5 style={{fontWeight: "700", marginBottom: "12px"}}>{dataKop?.name_school} </h5>
                    {/* <p style={{fontWeight: "700",lineHeight: "0px", marginBottom: "20px" }}>{dataKop.name_branch}</p> */}
                    <p style={{lineHeight: "4px", fontSize: "13px"}}> {dataKop?.address}, {dataKop?.district}, {dataKop?.postal_code}</p>
                    
                    <p style={{lineHeight: "4px", fontSize: "13px"}}>Telp : {dataKop.phone}</p>
                    <p style={{lineHeight: "4px", fontSize: "13px"}}> NPSN : {dataKop.npsn}</p>
                    <p style={{lineHeight: "4px", fontWeight: "700", fontSize: "13px"}}>Status Teraktreditasi : {dataKop.akreditasi} </p>
                  </div>
                </div>
                
                 <div className="col-2">
                  <img src={LogoYsb} style={{width: "89px", height: "89px"}}/>
                </div>

              </div>
              <hr style={{borderBottom: "5px solid #000", marginTop: "2px"}} />

              <div className="text-center mb-3">
                <h5 style={{fontWeight: 800}}>LAPORAN HASIL CAPAIAN ADAB</h5>
              </div>

              <div className="row mb-3" style={{fontSize: "13px"}}>
                <div className="col-7">
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody >
                      <tr>
                        <td
                          style={{
                            width: "145px",
                            paddingBottom: "3px",
                            verticalAlign: "top",
                            whiteSpace: "nowrap"
                          }}
                        >
                          Nama
                        </td>
                        <td
                          style={{
                            width: "14px",
                            paddingBottom: "3px",
                            verticalAlign: "top",
                            textAlign: "center",
                          }}
                        >
                          :
                        </td>
                        <td
                          style={{
                            paddingBottom: "3px",
                            verticalAlign: "top",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            lineHeight: "1.5",
                          }}
                        >
                          {toTitleCase(data?.name_student)}
                        </td>
                      </tr>

                      <tr>
                        <td
                          style={{
                            width: "145px",
                            paddingBottom: "3px",
                            verticalAlign: "top",
                            whiteSpace: "nowrap",
                          }}
                        >
                          NISN
                        </td>
                        <td
                          style={{
                            width: "14px",
                            paddingBottom: "3px",
                            verticalAlign: "top",
                            textAlign: "center",
                          }}
                        >
                          :
                        </td>
                        <td style={{ 
                          paddingBottom: "3px", 
                          verticalAlign: "top" }}>
                          {data?.nisn}
                        </td>
                      </tr>

                      <tr>
                        <td
                          style={{
                            width: "145px",
                            verticalAlign: "top",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Nama Sekolah
                        </td>
                        <td
                          style={{
                            width: "14px",
                            verticalAlign: "top",
                            textAlign: "center",
                          }}
                        >
                          :
                        </td>
                        <td
                          style={{
                            verticalAlign: "top",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            lineHeight: "1.5",
                          }}
                        >
                          {toSchoolCase(data?.ysb_school_name)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="col-5">
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            width: "105px",
                            paddingBottom: "3px",
                            verticalAlign: "top",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Kelas
                        </td>
                        <td
                          style={{
                            width: "14px",
                            paddingBottom: "3px",
                            verticalAlign: "top",
                            textAlign: "center",
                          }}
                        >
                          :
                        </td>
                        <td
                          style={{
                            paddingBottom: "3px",
                            verticalAlign: "top",
                            whiteSpace: "normal",
                            lineHeight: "1.5",
                          }}
                        >
                          {/* {data?.ysb_name_level} {toTitleCase(data?.ysb_name_kelas)} */}
                          {formatNamaKelas(data?.ysb_name_level, data?.ysb_name_kelas)}
                        </td>
                      </tr>

                      <tr>
                        <td
                          style={{
                            width: "105px",
                            paddingBottom: "3px",
                            verticalAlign: "top",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Tahun Ajaran
                        </td>
                        <td
                          style={{
                            width: "14px",
                            paddingBottom: "3px",
                            verticalAlign: "top",
                            textAlign: "center",
                          }}
                        >
                          :
                        </td>
                        <td
                          style={{
                            paddingBottom: "3px",
                            verticalAlign: "top",
                            whiteSpace: "normal",
                            lineHeight: "1.5",
                          }}
                        >
                          {data?.ysb_name_year}
                        </td>
                      </tr>

                      <tr>
                        <td
                          style={{
                            width: "105px",
                            verticalAlign: "top",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Semester
                        </td>
                        <td
                          style={{
                            width: "14px",
                            verticalAlign: "top",
                            textAlign: "center",
                          }}
                        >
                          :
                        </td>
                        <td
                          style={{
                            verticalAlign: "top",
                            whiteSpace: "normal",
                            lineHeight: "1.5",
                          }}
                        >
                          {data?.ysb_semester}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="table-print" style={{ marginBottom: "40px" }}>
                <table
                  className="table table-hover table-bordered"
                  style={{
                    border: "1px solid #585858ff",
                    width: "100%",
                    tableLayout: "auto",
                    fontSize: "13px"
                  }}
                >
                  <colgroup>
                    <col style={{ width: "12%" }} />
                    <col style={{ width: "45%" }} />
                    <col style={{ width: "15%" }} />
                    <col style={{ width: "28%" }} />
                  </colgroup>

                  <thead>
                    <tr>
                      <th
                        scope="col"
                        rowSpan={3}
                        style={{
                          // backgroundColor: "#ffbf80",
                          textAlign: "center",
                          border: "1px solid #585858ff",
                          verticalAlign: "middle",
                        }}
                      >
                        Muatan Adab
                      </th>
                      <th
                        scope="col"
                        rowSpan={3}
                        style={{
                          // backgroundColor: "#e2e2e2ff",
                          // backgroundColor: "#ffbf80",
                          textAlign: "center",
                          border: "1px solid #585858ff",
                          verticalAlign: "middle",
                        }}
                      >
                        Indikator
                      </th>
                      <th
                        scope="col"
                        colSpan={2}
                        rowSpan={2}
                        style={{
                          // backgroundColor: "#e2e2e2ff",
                          // backgroundColor: "#ffbf80",
                          textAlign: "center",
                          border: "1px solid #585858ff",
                          verticalAlign: "middle",
                        }}
                      >
                        KKCA
                      </th>
                    </tr>
                    <tr />
                    <tr>
                      <th
                        scope="col"
                        style={{
                          // backgroundColor: "#e2e2e2ff",
                          // backgroundColor: "#ffbf80",
                          textAlign: "center",
                          border: "1px solid #585858ff",
                        }}
                      >
                        Capaian
                      </th>
                      <th
                        scope="col"
                        style={{
                          // backgroundColor: "#e2e2e2ff",
                          // backgroundColor: "#ffbf80",
                          textAlign: "center",
                          border: "1px solid #585858ff",
                        }}
                      >
                        Deskripsi Pencapaian
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* kalau siswa tidak punya dimensi */}
                    {!raporForStudent || dimensiGroups.length === 0 ? (
                      <tr>
                        <td colSpan={4} style={{ padding: "12px", textAlign: "center" }}>
                          Data rapor belum tersedia.
                        </td>
                      </tr>
                    ) : (
                      (() => {
                        const rows = [];

                        dimensiGroups.forEach((group, gIdx) => {
                          const letter = String.fromCharCode(65 + gIdx); // A, B, C...
                          const groupTitle = group?.type || "Muatan Adab";

                          // ✅ HEADER GROUP (dari JSON: group.type)
                          rows.push(
                            // <tr key={`group-${gIdx}`}>
                            <tr
                              key={`group-${gIdx}`}
                              className={gIdx > 0 ? "group-row-print force-next-page" : "group-row-print"}
                            >
                              <th
                                colSpan={4}
                                style={{
                                  // backgroundColor: "#e2e2e2ff",
                                  // backgroundColor: "#ffbf80",
                                  border: "1px solid #585858ff",
                                  paddingLeft: "12px",
                                  textAlign: "left",
                                  borderTop: "2px solid #1f1f1f"
                                }}
                              >
                                {letter}. {groupTitle}
                              </th>
                            </tr>
                          );

                          (group.dimensis || []).forEach((dim, dimIdx) => {
                            // header per dimensi
                            rows.push(
                              <tr key={`dim-${gIdx}-${dimIdx}`}>
                                <th
                                  colSpan={4}
                                  style={{
                                    // backgroundColor: "#f0f0f0ff",
                                    // backgroundColor: "#ffce9d",
                                    border: "1px solid #585858ff",
                                    textAlign: "left",
                                    paddingLeft: "12px",
                                    borderTop: "2px solid #1f1f1f"
                                  }}
                                >
                                  {dimIdx + 1}. {dim?.ysb_dimensi_name || "-"}
                                </th>
                              </tr>
                            );

                            (dim?.data_elements || []).forEach((el, elIdx) => {
                              rows.push(
                                <tr key={`el-${gIdx}-${dimIdx}-${elIdx}`}>
                                  <td
                                    style={{
                                      lineHeight: "1.6",
                                       border: "1px solid rgb(124, 124, 124)",
                                      verticalAlign: "top",
                                      padding: "8px",
                                      textAlign: "justify"
                                    }}
                                  >
                                    {el?.description}  
                                  </td>

                                  {/* <td
                                    style={{
                                      lineHeight: "1.8",
                                       border: "1px solid rgb(124, 124, 124)",
                                      verticalAlign: "top",
                                      padding: "8px 10px",
                                      whiteSpace: "normal",
                                      textAlign: "left",
                                    }}
                                  >
                                    {(el?.sub_elements || []).length === 0 ? (
                                      "-"
                                    ) : (
                                      <ol style={{ margin: 0, paddingLeft: "18px" }}>
                                        {(el.sub_elements || []).map((sub, subIdx) => (
                                          <li key={`sub-${gIdx}-${dimIdx}-${elIdx}-${subIdx}`} style={{ marginBottom: "4px" }}>
                                            {cleanIndikator(sub?.ysb_sub_element_name) || "-"}
                                          </li>
                                        ))}
                                      </ol>
                                    )}
                                  </td> */}

                                  <td
  style={{
    lineHeight: "1.8",
    border: "1px solid rgb(124, 124, 124)",
    verticalAlign: "top",
    padding: "8px 10px",
    whiteSpace: "normal",
    textAlign: "justify",
    textJustify: "inter-word",
    wordBreak: "normal",
    overflowWrap: "break-word",
  }}
>
  {(el?.sub_elements || []).length === 0 ? (
    "-"
  ) : (
    <ol
      style={{
        margin: 0,
        paddingLeft: "18px",
      }}
    >
      {(el.sub_elements || []).map((sub, subIdx) => (
        <li
          key={`sub-${gIdx}-${dimIdx}-${elIdx}-${subIdx}`}
          style={{
            marginBottom: "4px",
            textAlign: "justify",
            textJustify: "inter-word",
            overflowWrap: "break-word",
          }}
        >
          {cleanIndikator(sub?.ysb_sub_element_name) || "-"}
        </li>
      ))}
    </ol>
  )}
</td>

                                  <td
                                    style={{
                                      lineHeight: "1.6",
                                      border: "1px solid rgb(124, 124, 124)",
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                      padding: "8px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {el?.kkca_description || "-"} 
                                  </td>

                                  <td
                                    style={{
                                      lineHeight: "1.8",
                                       border: "1px solid rgb(124, 124, 124)",
                                      verticalAlign: "top",
                                      padding: "8px 10px",
                                      whiteSpace: "normal",
                                      textAlign: "justify",
                                      textJustify: "inter-word",
                                      wordBreak: "normal",
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    {el?.kkca_description_full || "-"}
                                  </td>
                                </tr>
                              );
                            });
                          });
                        });

                        return rows;
                      })()
                    )}
                  </tbody>
                </table>
              </div>

              <div className="ttd mt-4" style={{fontSize: "13px"}}>
                <div className="row">
                  <div className="col-4">
                    
                  </div>
                  <div className="col-8 d-flex">
                    
                    <div
                      className="ml-auto"
                      style={{
                        textAlign: "center",
                        width: hasTeacher2 ? "100%" : "420px",
                        maxWidth: "100%",
                        paddingLeft: "45px"
                      }}
                    >
                      {hasTeacher2 ? (
                        <p >{cityName}, {formattedDate}</p>
                    ):(
                      <p style={{ textAlign: "right"}}>{cityName}, {formattedDate}</p>
                    )}
                       
                    </div>
                    
                    
                    
                  </div>
                </div>
                
                <div className="row" style={{ marginTop: "-20px" }}>
                  <div className="col-4">
                    <p>Orang Tua/Wali Peserta Didik</p>
                    <div style={{ height: "55px" }} />
                    <p>________________________________</p>
                  </div>

                  <div className="col-8 d-flex">
                    <div
                      className="ml-auto"
                      style={{
                        textAlign: "center",
                        width: hasTeacher2 ? "100%" : "420px",
                        maxWidth: "100%",
                      }}
                    >
                       {hasTeacher2 ? (
                        
                        <p style={{ paddingLeft:"50px"}}>
                        {/* Wali Kelas {data?.ysb_name_level} {toTitleCase(data?.ysb_name_kelas)}   */}
                        Wali Kelas {formatNamaKelas(data?.ysb_name_level, data?.ysb_name_kelas)}
                        </p>
                       
                       ):(
                        
                        <p  style={{ textAlign: "right", paddingRight: "15px"}}>
                        {/* Wali Kelas {data?.ysb_name_level} {toTitleCase(data?.ysb_name_kelas)}  */}
                         Wali Kelas {formatNamaKelas(data?.ysb_name_level, data?.ysb_name_kelas)}
                        </p>

                       )}

                      <div style={{ height: "55px" }} />

                    

                      {hasTeacher2 ? (
                        <div className="row" style={{ paddingLeft: "50px" }}>
                          <div className="col-6 text-center">
                            <p style={{ fontWeight: 600 }}>{toTitleCaseGelar(data?.ysb_name_teacher)}</p>
                          </div>

                          <div className="col-6 text-center">
                            <p style={{ fontWeight: 600 }}>{toTitleCaseGelar(data?.ysb_name_teacher2)}</p>
                          </div>
                        </div>
                      ) : (
                        <div style={{ textAlign: "right" }}>
                          <p style={{ fontWeight: 600, marginBottom: 0 }}>
                            {toTitleCaseGelar(data?.ysb_name_teacher)}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  
                </div>

                <div
                  className="row"
                  style={{ marginTop: "40px", textAlign: "center" }}
                >
                  <div style={{ width: "100%" }}>
                    <p>Mengetahui,</p>
                    <p style={{ marginTop: "-18px" }}>Kepala Sekolah</p>
                    <div style={{ height: "48px" }} />
                    <p style={{ fontWeight: 600 }}>{toTitleCaseGelar(data?.ysb_nama_kepsek)}</p>                    
                  </div>
                </div>
              </div>

           
              <div />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
